export const COLOR_WHITE = "#ffffff"
export const COLOR_BEER = "#EBBB40"
export const COLOR_WHITE_10 = "rgba(255, 255, 255, 0.1)"
export const COLOR_BLACK = "#000000"
export const COLOR_BLACK_80 = "rgba(0, 0, 0, 0.8)"
export const COLOR_NEUTRAL_90 = "#28292B"